<div class="container">
  <div class="row">
    @if (!isComponent) {
      <div class="col-12 my-5">
        <h3 class="text-primary text-center">Aviso de privacidad</h3>
      </div>
    }

    @if (privacy) {
      <div class="col-12 pb-4">
        <div class="text-justify" [innerHTML]="privacy"></div>
      </div>
    }
  </div>
</div>
